<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Avantages des Campagnes PUBAG",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout },

  data() {
    return {
      items: [
      {
        icon: 'recycling-recycle',
        alt: 'recycling-recycle',
        title: 'atouts.1.title',
        description: 'atouts.1.description'
      },
      {
        icon: 'graph-svgrepo-com',
        alt: 'graph',
        title: 'atouts.2.title',
        description: 'atouts.2.description'
      },
      {
        icon: 'users-2-svgrepo-com',
        alt: 'users',
        title: 'atouts.3.title',
        description: 'atouts.3.description'
      },
      {
        icon: 'clock-circle-svgrepo-com',
        alt: 'clock-circle',
        title: 'atouts.4.title',
        description: 'atouts.4.description'
      },
      {
        icon: 'cogwheel-svgrepo-com',
        alt: 'cogwheel',
        title: 'atouts.5.title',
        description: 'atouts.5.description'
      },
      {
        icon: 'share-svgrepo-com',
        alt: 'share',
        title: 'atouts.6.title',
        description: 'atouts.6.description'
      },
      {
        icon: 'target-and-arrow-svgrepo-com',
        alt: 'target',
        title: 'atouts.7.title',
        description: 'atouts.7.description'
      },
      {
        icon: 'analyse-svgrepo-com',
        alt: 'analyse',
        title: 'atouts.8.title',
        description: 'atouts.8.description'
      },      {
        icon: 'smart-home-angle-svgrepo-com',
        alt: 'smart',
        title: 'atouts.9.title',
        description: 'atouts.8.description'
      }
      ]
    };
  },

  mounted() {
    this.observeIcons();
  },

  methods: {
    observeIcons() {
      const icons = document.querySelectorAll('.icon-slide-in');
      
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
      });

      icons.forEach(icon => {
        observer.observe(icon);
      });
    }
  }
};
</script>

<template>
  <Layout>


    <div class="bg-white text-center pt-md-5 pb-md-5 pt-0 pb-0 pr-2 pl-2">
      <div>
        <div class="pt-0">
          <h1 class="pt-5 text-dark text-wrap font-weight-bold" style="font-size:2.5rem;">
            {{$t('atouts.campagnesBenefits')}}
          </h1>
        </div>

        <hr class="separator-line mt-3 mb-3">

        <div class="mt-5 pb-5 pb-md-0">
          <h6 class="header-60-width mx-auto text-dark font-size-16 text-wrap" style="letter-spacing: 0.08em; line-height: 1.8;">
            {{$t('atouts.atouts')}}  <strong>{{$t('default.companyName')}}</strong> {{$t('atouts.visibility')}} 
          </h6>
        </div>
      </div>
    </div>










    <!-- <div class="header text-center pb-5">
      <div>
        <div class="pt-4">
          <h1 class="pt-5 text-white text-wrap">
            {{$t('atouts.campagnesBenefits')}}
          </h1>
        </div>

        <hr class="separator-line mt-5">

        <div class="mt-4">
          <h6 class="header-60-width mx-auto text-light text-wrap" style="letter-spacing: 0.08em; line-height: 1.8;">
            {{$t('atouts.atouts')}}  <strong>{{$t('default.companyName')}}</strong> {{$t('atouts.visibility')}}
          </h6>
        </div>
      </div>
    </div> -->

    <div class="bg-white pb-5">
      <div class="pt-5 header-60-width">
        <div class="row mt-md-5 mb-4 pb-md-5 pt-0 align-items-center " v-for="(item, index) in items" :key="index" >
          <div class="col-md-3 col-12 text-center mb-md-0 mb-4" >
            <img :alt="item.alt" width="80px" :src="require(`@/assets/icons/${item.icon}.svg`)" class="icon-slide-in"/>
          </div>

          <div class="col-md-9">
            <div class="align-items-center mb-2 row">
              <!-- <div class="col-2  text-center">
                <span class="circle-atouts ">{{ index + 1 }}</span>
              </div> -->
              <div class="col-12 text-md-left text-center">
                <span class="text-uppercase text-primary font-weight-bold " style="font-size:1.5rem;">{{ $t(item.title) }}</span>
              </div>
            </div>

            <div class="font-size-16 text-dark" style="letter-spacing: 0.08em; line-height: 1.8;">
              {{ $t(item.description) }}
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- <div class="header text-center pb-5 mt-5">
      <div>
        <div class="pt-4">
          <h1 class="pt-5 text-white text-wrap">
            {{$t('default.needs')}}
          </h1>
        </div>

        <hr class="separator-line mt-5">

        <div class="mt-4">
          <h6 class="header-60-width mx-auto text-light text-wrap" style="letter-spacing: 0.08em; line-height: 1.8;">
            {{$t('default.needsDescription')}}
          </h6>
        </div>
      </div>

      <router-link to="/devis">
        <b-button class="mt-4 pr-4 pl-4 text-uppercase font-size-18" style="background-color: #f7d584;">
          <span class=" text-primary">{{$t('default.requestQuote')}}</span> 
        </b-button>
      </router-link>
      <div class="font-size-12 mt-1 text-uppercase" style="color: #f7d584;">
        {{$t('default.requestQuoteResponse')}}
      </div>

    </div> -->

    <div class="pt-5  mb-3 pb-5 text-center bg-primary">
      <div class="mb-4 p-md-0 p-2">
        <div class="text-white font-weight-bold " style="font-size: 20px" >
          {{$t('concept.advisors01')}}
        </div>
          <div class="text-white font-weight-bold " style="font-size: 20px" >
            {{$t('concept.advisors02')}}
        </div>
      </div>
     
      <a class="pr-3 bg-wh " href="/devis">
        <b-button variant="warning"  style="padding: 10px 26px; letter-spacing:3px;" class="font-weight-bold font-size-18 m-md-0 m-2">
          <div class="font-weight-normal d-none d-md-block font-size-12">Je souhaite améliorer ma visibilité </div>
          <span class="d-none d-md-inline">Demander un </span>Devis Gratuit
        </b-button>
      </a>  

     <div class="font-size-12 mt-2 text-light text-uppercase">{{$t('default.requestQuoteResponse')}}</div> 
    </div>


  </Layout>
</template>



<style scoped>


.header {
  background:  linear-gradient(19deg,rgba(55, 152, 91, 1) 0%,rgba(19, 116, 55, 1) , rgba(23, 83, 45, 1) 100%)!important;
  text-align: center;
}

.header-60-width,
.sub-title-60-width {
  max-width: 80%;
  margin: auto;
}

@media (min-width: 768px) {
  .header-60-width,
  .sub-title-60-width {
      max-width: 60%;
  }
}
.separator-line {
  width: 15%;
  height: 4px;
  background-color: #f7d584 ;
  border: none;
  margin: auto;
}

.sub-title-60-width {
  margin: 30px auto 0;
  color: #f7d584;
}

.responsive-iframe {
  height: 450px;
}

@media (min-width: 768px) {
  .responsive-iframe {
      height: 650px;
  }
}




.circle-atouts {
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, #137437, #57b479);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 30px;
  font-weight: bold;
  box-shadow: 0px 4px 10px #57b479;
}




</style>



<style scoped>
@keyframes slideInFromLeft {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.header {
  background: linear-gradient(19deg, rgba(55, 152, 91, 1) 0%, rgba(19, 116, 55, 1), rgba(23, 83, 45, 1) 100%) !important;
  text-align: center;
}

.header-60-width,
.sub-title-60-width {
  max-width: 80%;
  margin: auto;
}

@media (min-width: 768px) {
  .header-60-width,
  .sub-title-60-width {
    max-width: 60%;
  }
}

.separator-line {
  width: 15%;
  height: 4px;
  background-color: #137437;
  border: none;
  margin: auto;
}

.sub-title-60-width {
  margin: 30px auto 0;
  color: #f7d584;
}

.responsive-iframe {
  height: 450px;
}

@media (min-width: 768px) {
  .responsive-iframe {
    height: 650px;
  }
}

.circle-atouts {
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, #137437, #57b479);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 30px;
  font-weight: bold;
  box-shadow: 0px 4px 10px #57b479;
  transition: all 0.3s ease;
}

/* Hide icons initially */
.icon-slide-in {
  transform: translateX(-100%);
  opacity: 0;
  transition: transform 1s ease-out, opacity 1s ease-out;
}

/* Add the animation when the icon is in view */
.icon-slide-in.animate {
  transform: translateX(0);
  opacity: 1;
}

</style>